import React, {Component, Fragment} from 'react';
import './PageWrapper.module.scss';

import { connect } from 'react-redux';


const mapStateToProps = (state) => {
    return {
        sidebar: state.sidebar
    };
  };

class PageWrapper extends Component {

    render() {

        return (
                <div styleName={`pagewrapper ${this.props.sidebar.open ? 'openSidebar' : ''}`}>
                    {this.props.children}
                </div>
        );  
    }
}

export default connect(mapStateToProps, null)(PageWrapper);


// WEBPACK FOOTER //
// ./resources/assets/components/UI/PageWrapper/PageWrapper.jsx